export { createIntegration } from "./createIntegration";

export enum IntegrationKind {
  Test = "test",
  Klaviyo = "klaviyo",
  Dsco = "dsco",
  Judgeme = "judgeme",
}

export enum ProviderKind {
  Test = "test",
}
